import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'app/lib/api.service';
import { SeriesService } from 'app/lib/series.service';
import { UserService } from 'app/lib/user.service';
import { User } from 'app/models/user';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-series-dashboard',
    templateUrl: './series-dashboard.component.html',
    styleUrls: ['./series-dashboard.component.scss'],
    standalone: false
})
export class SeriesDashboardComponent implements OnInit {
    user: User;
    categoryList = [];
    private categorySubscription: Subscription | null = null;
    seriesTypes: Array<any> = ['video', 'audio', "reads", 'daily' ];
    // seriesTypes: Array<any> = ['video', 'audio'];
    enableVoiceSeries: boolean;
    enableDailySeries: boolean;
    enableReadsSeries: boolean;
    isLoaded: boolean = false;
    organizationOwnContentTitle: string = "";
    enableOrganizationOwnContents: boolean = false;
    lang: string = "en";
    enabledSeriesCount: number = 0;
    seriesGridClass: string = "";
    constructor(
        private api: ApiService,
        private router: Router,
        private userService: UserService,
        private seriesService: SeriesService,
        private translate: TranslateService
    ) {
        this.getCategories();
        this.enableVoiceSeries =
            this.seriesService.checkSeriesTypesEnabled().enableStorySeries ||
            this.seriesService.checkSeriesTypesEnabled()
                .enableBurningQuestionSeries;
        this.enableDailySeries =
            this.seriesService.checkSeriesTypesEnabled().enableDailySeries;
            this.enableReadsSeries =
      this.seriesService.checkSeriesTypesEnabled().enableReadsSeries;
    }

    ngOnInit(): void {
        this.lang = this.translate.currentLang;
        this.user = this.userService.getUser();
        this.calculateEnabledSeriesCount();
        this.user?.primaryOrganization?.settings?.enableOrganizationOwnContents &&
      this.setOrgOwnContent();
    }
    getCategories() {
        this.seriesService.categories.subscribe(
            data => {
                this.categoryList = data;
                this.isLoaded = true;
            },
            (error: any) => {
                this.categoryList = [];
                this.isLoaded = true;
            }
        );
        this.seriesService.getCategories();
    }
    categoryDetail(resource) {
        // this.router.navigate('series')
    }
    checkSeriesEnabled(type: string) {
        switch (type) {
            case 'video':
                return true;
            case 'audio':
                return this.enableVoiceSeries;
            case 'daily':
                return this.enableDailySeries;
            case "reads":
                return this.enableReadsSeries;
        }
    }
    
    calculateEnabledSeriesCount(): void {
        let count = 0;
        for (const type of this.seriesTypes) {
            if (this.checkSeriesEnabled(type)) {
                count++;
            }
        }
        this.enabledSeriesCount = count;
        this.seriesGridClass = count <= 2 ? 'series-type-list--compact' : '';
    }
    goToSeries(type: string, category) {
        if (!this.user.isFullAccess) {
            // this.showBlocked();
        } else {
            switch (type) {
                case 'type':
                    this.router.navigate(['/app/series/' + category]);
                    break;
                case 'category':
                    this.router.navigate([
                        '/app/series/category-details/' + category,
                    ]);
                    break;
            }
        }
    }
    shouldShowCategory(category: any): boolean {
        return (
            category.Key !== 'all' &&
            (category.hasVideos > 0 ||
                category.hasStories > 0 ||
                category.hasDailySeries > 0 ||
                category.hasBurningQuestions > 0  ||
                category.hasReads > 0)
        );
    }
    goToOrganizationContent() {
    this.router.navigate(["/app/series/org-series-contents"]);
  }
    // setOrgOwnContent() {
    //     this.enableOrganizationOwnContents =
    //         this.user?.primaryOrganization?.settings?.enableOrganizationOwnContents ||
    //         false;

    //     this.organizationOwnContentTitle =
    //         this.user?.primaryOrganization?.settings[
    //         "organizationOwnContentTitle" + this.lang.replace(/^\w/, (c) => c.toUpperCase())
    //         ] || "";
    // }

    setOrgOwnContent() {
        this.enableOrganizationOwnContents =
            this.user?.primaryOrganization?.settings?.enableOrganizationOwnContents ?? false;

        const settings = this.user?.primaryOrganization?.settings;

        const key =
            "organizationOwnContentTitle" +
            this.lang.replace(/^\w/, (c) => c.toUpperCase());

        this.organizationOwnContentTitle =
            settings?.[key] || settings?.organizationOwnContentTitleEn || "";
    }
}